<script setup lang="ts">
import { ref } from 'vue'
import useOutstandingRepurchase from '../../../../../Composables/Restructuring/useOutstandingRepurchase.ts'
import type {
  AnyRepurchasedContract,
  ContractRestructuringWithOutstandingRepurchase,
} from '../../../../../Types/restructuring'
import BlockContent from '../../UI/Content/BlockContent.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import RepurchasedContractList from '../RepurchasedContractList.vue'

type FormCreatorType = InstanceType<typeof FormCreator>

const props = defineProps<{
  restructuring: ContractRestructuringWithOutstandingRepurchase
  form: FormCreatorType
}>()

const action = ref(props.restructuring.outstandingRepurchase)

const { contracts, externalContracts, totalRepurchaseAmount } = useOutstandingRepurchase(action)

function updateContracts(contracts: AnyRepurchasedContract[]) {
  action.value.contracts = contracts
}
</script>
<template>
  <BlockContent class="mt-2 px-0">
    <div class="row mt-2">
      <div class="col-12">
        <RepurchasedContractList :action="action" @update:contracts="updateContracts" />
      </div>
    </div>
  </BlockContent>
  <BlockContent class="mt-2 px-0">
    <h6>{{ $t('restructuring.summary') }}</h6>
    <div class="row">
      <div class="col-4">
        <div class="font-weight-bold">
          {{ $t('restructuring.fields.contracts.label') }}
        </div>
        <div>
          {{ contracts.length }}
        </div>
      </div>
      <div class="col-4">
        <div class="font-weight-bold">
          {{ $t('restructuring.fields.outstandingRepurchase.externalContracts.label') }}
        </div>
        <div>
          {{ externalContracts.length }}
        </div>
      </div>
      <div class="col-4">
        <div class="font-weight-bold">
          {{ $t('restructuring.fields.outstandingRepurchase.repurchaseAmount.label') }}
        </div>
        <div>
          {{ $n(totalRepurchaseAmount, 'currency') }}
        </div>
      </div>
    </div>
  </BlockContent>
</template>
